import React from 'react';

import './EacCheck.scss';
import modelList from '../../content/models.json';
import EacTextJSON from "../../content/EacText.json";

import Popup from '../Popup/Popup';
import EacText from "./EacText";
import StepOne from "../Steps/StepOne";
import StepTwo from "../Steps/StepTwo";
import Pagination from "../Pagination/Pagination";
import Links from "../Popup/Links";

class EacCheck extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      region: props.region,
      currentStep: 0,
      stepOneStatus: null,
      stepTwoStatus: null,
      eacInputHasError: false,
      eacInputSuffixHasError: false,
      eacValue: '',
      eacValueSuffix: '',
      popupData: {
        step1: {
          title: 'Пример маркировки EAC',
          img: process.env.PUBLIC_URL + '/step-1.jpg',
          position: 'center',
          showNote: false,
        },
        step2: {
          title: 'Где найти номер модели и суффикс',
          img: process.env.PUBLIC_URL + '/step-2.jpg',
          position: 'center',
          showNote: false,
        },
        prefix: {
          title: 'Где найти номер модели и суффикс',
          img: process.env.PUBLIC_URL + '/prefix.jpg',
          position: 'center',
          showNote: false,
        },
        success: {
          icon: "success",
          title: "Модель найдена",
          text: "Ваш телевизор сертифицирован и&nbsp;вы&nbsp;можете продолжать пользоваться услугой LG&nbsp;Smart&nbsp;TV.",
          position: 'center big',
        },
        fail: {
          icon: "fail",
          title: "Модель не&nbsp;найдена",
          text: "На основе введенных данных модель не&nbsp;найдена.<br/> За&nbsp;более подробной обращайтесь в&nbsp;Службу поддержки клиентов&nbsp;LG.",
          position: 'center big',
        }
      },

    }

  }

  handleStepOne(answer) {

    let { stepOneStatus, currentStep, popupData } = this.state;
    const { popupHandler } = this.props;

    currentStep = answer ? 1 : 0;
    stepOneStatus = answer ? null : "error";

    if (!answer) {
      popupHandler(popupData["fail"]);
    }

    this.setState({ currentStep, stepOneStatus });

  }

  sendGANo = (eacValue, eacValueSuffix) => {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        "event": "tvcheck",
        "eventCategory": "tvcheck",
        "eventAction": "yes",
        "eventLabel": `${eacValue}-${eacValueSuffix}`
      });
      console.log(`Send GA Event ${eacValue}-${eacValueSuffix}`);
    } catch (e) {}
  };

  validateEac() {
    const { eacValue, eacValueSuffix, region, popupData } = this.state;
    if (eacValue.length < 1 || eacValueSuffix.length < 1) {

      if (eacValue.length < 1) {
        this.props.popupHandler(popupData.step2);
      } else {
        this.props.popupHandler(popupData.prefix);
      }

      this.setState({
        eacInputHasError: eacValue.length < 1,
        eacInputSuffixHasError: eacValueSuffix.length < 1
      });
      return false;
    }

    let passStatus = "fail";

    if (eacValueSuffix.toUpperCase().includes(region)) {
      passStatus = modelList.models.indexOf(`${eacValue.toUpperCase()}`) !== -1 ? "success" : "fail";
    }

    this.sendGANo(eacValue, eacValueSuffix);

    this.props.popupHandler(this.state.popupData[passStatus]);

    this.setState({ stepTwoStatus: passStatus })

  };

  changeStep(currentStep) {
    this.setState({ currentStep });
  }

  inputEACSuffixHandler(event) {
    let { eacInputSuffixHasError, eacValueSuffix } = this.state;

    eacValueSuffix = event.target.value;
    eacInputSuffixHasError = eacValueSuffix.length >= 1 ? false : eacInputSuffixHasError;

    this.setState({
      eacValueSuffix,
      eacInputSuffixHasError
    });
  }

  inputEACHandler(event) {
    let { eacInputHasError, eacValue } = this.state;

    eacValue = event.target.value;
    eacInputHasError = eacValue.length >= 1 ? false : eacInputHasError;

    this.setState({
      eacValue,
      eacInputHasError
    });

  }

  render() {

    const { popupHandler, activePopup } = this.props;
    const { eacValueSuffix, currentStep, eacValue, popupData, stepOneStatus, stepTwoStatus, eacInputSuffixHasError, eacInputHasError } = this.state;

    return (
      <div className="eac-check-section">
        <div className="eac-check__inner">

          <EacText title={EacTextJSON.title}
                   subtitle={EacTextJSON.subtitle} />

          <Links popupData={popupData}
                 popupHandler={popupHandler} />

          <div className="eac-check__steps">
            {!currentStep
              ? <StepOne
                handleStepOne={this.handleStepOne.bind(this)}
                stepOneStatus={stepOneStatus} />
              : <StepTwo popupData={popupData}
                         eacInputHasError={eacInputHasError}
                         eacInputSuffixHasError={eacInputSuffixHasError}
                         inputEACHandler={this.inputEACHandler.bind(this)}
                         inputEACSuffixHandler={this.inputEACSuffixHandler.bind(this)}
                         currentStep={currentStep}
                         eacValue={eacValue}
                         eacValueSuffix={eacValueSuffix}
                         stepTwoStatus={stepTwoStatus}
                         validateEac={this.validateEac.bind(this)} />
            }
            <Pagination currentStep={currentStep}
                        changeStep={this.changeStep.bind(this)} />
          </div>
        </div>
        {activePopup
          ? <Popup
            icon={activePopup.icon}
            title={activePopup.title}
            img={activePopup.img}
            text={activePopup.text}
            position={activePopup.position}
            showNote={activePopup.showNote}
            onClose={popupHandler}
          />
          : null
        }
      </div>
    )
  }
};

export default EacCheck;
